<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-6" style="display: flex;justify-content: start;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioFiltroTipoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" [label]="'Tipo de Vendedor *'" formControlName="idTipoVendedor"
          [control]="formularioFiltroTipoDeVendedores.get('idTipoVendedor')" [id]="'idTipoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12" *ngIf="!isCreate">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idAsignacion'" formControlName="idAsignacion"
          [control]="formulario.get('idAsignacion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Inicio'"
          [label]="'Fecha Inicio *'" [id]="'fechaInicioDDMMYYYY'" formControlName="fechaInicioDDMMYYYY"
          [control]="formulario.get('fechaInicioDDMMYYYY')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Fin'"
          [label]="'Fecha Fin *'" [id]="'fechaFinDDMMYYYY'" formControlName="fechaFinDDMMYYYY"
          [control]="formulario.get('fechaFinDDMMYYYY')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-5">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-7">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor1'" [idOpcion]="'idVendedor'"
          [comboBox]="listVendedores" formControlName="vendedorId" [control]="formulario.get('vendedorId')"
          [label]="'Vendedor *'" [id]="'vendedorId'">
        </app-lfsa-combo-box>
      </div>
      <!-- <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Vendedor'"
          [label]="'Vendedor *'" [id]="'vendedorId'" formControlName="vendedorId"
          [control]="formulario.get('vendedorId')" (change)="onChangeVendedor($event);"
          (keyup)="onChangeVendedor($event);"></app-lfsa-input>
      </div> -->
      <!-- <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Nombre de Vendedor'" [label]="'Nombre de Vendedor *'"
          [id]="'nombreVendedorDescripcion'" formControlName="nombreVendedorDescripcion"
          [control]="formulario.get('nombreVendedorDescripcion')"></app-lfsa-input>
      </div> -->
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Usuario de Carga'" [label]="'Usuario de Carga *'" [id]="'usuarioCarga'"
          formControlName="usuarioCarga" [control]="formulario.get('usuarioCarga')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Sueldo Variable'" [label]="'Sueldo Variable *'" [id]="'sueldoVariable'"
          formControlName="sueldoVariable" [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Estado Asignación'" [label]="'Estado Asignación *'" [id]="'estado'"
          formControlName="estado" [control]="formulario.get('estado')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Fecha de Carga'" [label]="'Fecha de Carga *'" [id]="'fechaCargaDDMMYYYY'"
          formControlName="fechaCargaDDMMYYYY" [control]="formulario.get('fechaCargaDDMMYYYY')"></app-lfsa-input>
      </div>
    </div>
  </div>
  <hr>
  <div *ngIf="formulario.invalid" style="text-align: center;">
    Necesitas tener una cabecera válida para agregar detalles.
  </div>
  <div *ngIf="!formulario.invalid" [formGroup]="formularioDetalle" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idVariable'"
          [comboBox]="listTiposDeVariables" formControlName="variableId" [control]="formularioDetalle.get('variableId')"
          [label]="'Seleccione Variable *'" [id]="'variableId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Valor Peso'"
          [label]="'Valor Peso *'" [id]="'valorPeso'" formControlName="valorPeso"
          [control]="formularioDetalle.get('valorPeso')"></app-lfsa-input>
      </div>
      <div class="form-group col-md-1" style="display: flex;justify-content: start;align-items: center;">
        <button (click)="agregarDetalle()"
          [disabled]="formularioDetalle.invalid || (variableSeleccionada.tipoVariable == 'DISTRIBUIDA' && listSubDistribucion.length == 0)"
          class={{DAT_BTNCSS.success}}>+</button>
      </div>
      <div class="form-group col-md-3" style="display: flex;justify-content: start;align-items: center;">
        <button *ngIf="variableSeleccionada.tipoVariable == 'DISTRIBUIDA'" (click)="agregarDistribucion()"
          class={{DAT_BTNCSS.success}} [disabled]="formularioDetalle.invalid">Agregar
          SubDistribución</button>
      </div>
    </div>
  </div>
  <hr>
  <div class="mb-3" *ngIf="listDetalles.length == 0" style="text-align: center;">
    No ha agregado ningún detalle
  </div>
  <div *ngIf="listDetalles.length > 0">
    <table class="table table-bordered table-hover" style="width: 100%;">
      <thead>
        <tr>
          <th>Tipo Vendedor</th>
          <th>Variable Asignada</th>
          <th>Valor en Dolares</th>
          <th>Peso Asignado</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let detalle of listDetalles; index as i">
          <td>{{ detalle.tipoVendedorDescripcion }}</td>
          <td>{{ detalle.variableDescripcion }}</td>
          <td>{{ detalle.dolares }}</td>
          <td>{{ detalle.valorPeso }}</td>
          <td><button (click)="eliminarDetalle(i)" class={{DAT_BTNCSS.danger}}>X</button></td>
          <td><button *ngIf="detalle.variableDistribuida"
              (click)="verDistribucion(detalle.asignacionId,detalle.variableId,i)" class={{DAT_BTNCSS.info}}>Ver</button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="2" align="right">
            Total Pesos
          </th>
          <th>{{ totalDolares }}</th>
          <th>{{ totalPesos }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="row">
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>
</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'SubDistribución'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div *ngIf="isCreateSubDistribucion" [formGroup]="formularioCategorias" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcionMacroCategoria'"
          [idOpcion]="'idMacroCategoria'" [comboBox]="listMacroCategorias" formControlName="macroCategoria"
          [control]="formularioCategorias.get('macroCategoria')" [label]="'Macro categoría *'" [id]="'macroCategoria'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcionLinea'" [idOpcion]="'idLinea'"
          [comboBox]="listLineas" formControlName="linea" [control]="formularioCategorias.get('linea')"
          [label]="'Línea *'" [id]="'linea'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcionCategoria'" [idOpcion]="'idCategoria'"
          [comboBox]="listCategroias" formControlName="categoria" [control]="formularioCategorias.get('categoria')"
          [label]="'Categoría *'" [id]="'categoria'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcionSubCategoria'"
          [idOpcion]="'idSubCategoria'" [comboBox]="listSubCategorias" formControlName="subCategoria"
          [control]="formularioCategorias.get('subCategoria')" [label]="'SubCategoría *'" [id]="'subCategoria'">
        </app-lfsa-combo-box>
      </div>
      <!-- No aplica valor del peso
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Valor Peso'"
          [label]="'Valor Peso *'" [id]="'valorPeso'" formControlName="valorPeso"
          [control]="formularioCategorias.get('valorPeso')"></app-lfsa-input>
      </div>
      -->
      <div class="form-group col-md-4" style="display: flex;justify-content: start;align-items: center;">
        <button (click)="agregarSubCategoria()" class={{DAT_BTNCSS.success}}
          [disabled]="formularioCategorias.invalid">Agregar SubCategoria</button>
      </div>
    </div>
    <hr>
  </div>
  <div *ngIf="listSubDistribucion.length == 0" style="text-align: center;">
    No ha agregado ninguna subCategoria
  </div>
  <div *ngIf="listSubDistribucion.length > 0">
    <table class="table table-bordered table-hover" style="width: 100%;">
      <thead>
        <tr>
          <th>SubCategoria</th>
          <!-- <th>Peso Asignado</th> -->
          <th *ngIf="isCreateSubDistribucion"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subCategoria of listSubDistribucion; index as i">
          <td>{{ subCategoria.nombreSubcategoria }}</td>
         <!-- <td>{{ subCategoria.valorPeso }}</td> -->
          <td *ngIf="isCreateSubDistribucion"><button (click)="eliminarsubCategoria(i)" class={{DAT_BTNCSS.danger}}>X</button></td>
        </tr>
      </tbody>
      <tfoot>
        <tr><!-- Total Pesos -->
          <th align="right">
            Total Categorias
          </th>
          <th>{{ totalPorcentaje }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
  <div *ngIf="isCreateSubDistribucion" class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <!-- [disabled]="totalPorcentaje != 100" -->
      <button class="btn btn-success btn-block" [disabled]="totalPorcentaje < 1" (click)="guardarSubCategorias()">
        <i class="fa fa-save"></i> Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>